import { render, staticRenderFns } from "./create.vue?vue&type=template&id=7bf3c6b8&scoped=true"
import script from "./create.vue?vue&type=script&setup=true&lang=js"
export * from "./create.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3c6b8",
  null
  
)

export default component.exports